import script from "./HireMeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HireMeModal.vue?vue&type=script&setup=true&lang=js"

import "./HireMeModal.vue?vue&type=style&index=0&id=6274c42e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6274c42e"]])

export default __exports__